var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import OkCancelModal from '@/shared/components/OkCancelModal';
import ToastrService from '@/shared/services/ToastrService';
import { useChangePassword } from '@/shared/hooks/profile/useChangePassword';
import { validatePassword, isPasswordValid } from '../components/passwordValidation';
import { useRecaptcha } from '../components/useRecaptcha';
import messages from '../profileMessages';
var ChangePasswordModal = function (_a) {
    var show = _a.show, onClose = _a.onClose;
    var intl = useIntl();
    var changePassword = useChangePassword().changePassword;
    var _b = useRecaptcha('g-recaptcha-password', 'change_password', show), captchaToken = _b.token, resetCaptcha = _b.reset;
    var _c = useState(''), oldPassword = _c[0], setOldPassword = _c[1];
    var _d = useState(''), newPassword = _d[0], setNewPassword = _d[1];
    var _e = useState(''), newPassword2 = _e[0], setNewPassword2 = _e[1];
    var _f = useState({ old: false, new: false, confirm: false }), dirty = _f[0], setDirty = _f[1];
    var pwdValidation = validatePassword(newPassword);
    var passwordsMatch = newPassword === newPassword2;
    var formValid = oldPassword.length > 0 &&
        isPasswordValid(newPassword) &&
        passwordsMatch &&
        newPassword2.length > 0;
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, changePassword({
                            oldPassword: oldPassword,
                            newPassword: newPassword,
                            newPassword2: newPassword2,
                            captcha: captchaToken,
                            captchaAction: 'change_password',
                        })];
                case 1:
                    _b.sent();
                    ToastrService.success(intl.formatMessage(messages.PasswordChanged));
                    handleClose();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    resetCaptcha();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleClose = function () {
        setOldPassword('');
        setNewPassword('');
        setNewPassword2('');
        setDirty({ old: false, new: false, confirm: false });
        onClose();
    };
    return (_jsx(OkCancelModal, __assign({ title: intl.formatMessage(messages.ChangePassword), show: show, onSave: handleSave, onClose: handleClose, disabled: !formValid || !captchaToken, okLabel: intl.formatMessage(messages.ChangePassword) }, { children: _jsxs("div", __assign({ className: "form-horizontal" }, { children: [_jsxs("div", __assign({ className: classNames('form-group', {
                        'has-error': dirty.old && !oldPassword,
                    }) }, { children: [_jsx("label", __assign({ className: "control-label col-md-4" }, { children: intl.formatMessage(messages.OldPassword) })), _jsxs("div", __assign({ className: "col-md-8" }, { children: [_jsx("input", { type: "password", className: "form-control", value: oldPassword, onChange: function (e) {
                                        setOldPassword(e.target.value);
                                        setDirty(function (d) { return (__assign(__assign({}, d), { old: true })); });
                                    } }), dirty.old && !oldPassword && (_jsx("ul", __assign({ className: "help-block" }, { children: _jsx("li", { children: intl.formatMessage(messages.FieldRequired) }) })))] }))] })), _jsxs("div", __assign({ className: classNames('form-group', {
                        'has-error': dirty.new && !isPasswordValid(newPassword),
                    }) }, { children: [_jsx("label", __assign({ className: "control-label col-md-4" }, { children: intl.formatMessage(messages.NewPassword) })), _jsxs("div", __assign({ className: "col-md-8" }, { children: [_jsx("input", { type: "password", className: "form-control", value: newPassword, onChange: function (e) {
                                        setNewPassword(e.target.value);
                                        setDirty(function (d) { return (__assign(__assign({}, d), { new: true })); });
                                    } }), dirty.new && (_jsxs("ul", __assign({ className: "help-block" }, { children: [!newPassword && _jsx("li", { children: intl.formatMessage(messages.FieldRequired) }), !pwdValidation.pwdLength && _jsx("li", { children: intl.formatMessage(messages.PwdLength) }), !pwdValidation.pwdCapital && _jsx("li", { children: intl.formatMessage(messages.PwdCapital) }), !pwdValidation.pwdNonCapital && (_jsx("li", { children: intl.formatMessage(messages.PwdLowercase) })), !pwdValidation.pwdNumber && _jsx("li", { children: intl.formatMessage(messages.PwdDigit) }), !pwdValidation.pwdSpecial && (_jsx("li", { children: intl.formatMessage(messages.PwdSpecial, { chars: '\\,-,!,@,#,$,%,^,&,*,.' }) }))] })))] }))] })), _jsxs("div", __assign({ className: classNames('form-group', {
                        'has-error': dirty.confirm && (!newPassword2 || !passwordsMatch),
                    }) }, { children: [_jsx("label", __assign({ className: "control-label col-md-4" }, { children: intl.formatMessage(messages.RepeatNewPassword) })), _jsxs("div", __assign({ className: "col-md-8" }, { children: [_jsx("input", { type: "password", className: "form-control", value: newPassword2, onChange: function (e) {
                                        setNewPassword2(e.target.value);
                                        setDirty(function (d) { return (__assign(__assign({}, d), { confirm: true })); });
                                    } }), dirty.confirm && (_jsxs("ul", __assign({ className: "help-block" }, { children: [!newPassword2 && _jsx("li", { children: intl.formatMessage(messages.FieldRequired) }), newPassword2 && !passwordsMatch && (_jsx("li", { children: intl.formatMessage(messages.PasswordsMustMatch) }))] })))] }))] })), _jsx("div", __assign({ className: "form-group" }, { children: _jsx("div", __assign({ className: "flex-container" }, { children: _jsx("div", { id: "g-recaptcha-password", className: "center" }) })) }))] })) })));
};
export default ChangePasswordModal;
